// extracted by mini-css-extract-plugin
export default {"like":"_24NmA","not-clickable":"_23Wh5","notClickable":"_23Wh5","likebutton":"_2aT07","likes":"_1OKXK"};